export default __webpack_public_path__ + "static/media/B783.b0da34b7.webp";